const checkIfEmpty = (obj) => {
  if (obj && Object.keys(obj).length === 0) {
    return true;
  }
  return false;
};

const setAllObjectProperties = (obj, value) => {
  const newObj = Object.keys(obj).reduce((acc, cur) => {
    acc[cur] = value;
    return acc;
  }, {});
  return newObj;
};

const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        reject(new Error(`Failed to load the script ${src}`));
      };
      document.body.appendChild(script);
    } catch (error) {
      reject(error);
    }
  });
};

const STATUS = Object.freeze({
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
});

const NOTIFICATION_TYPE = Object.freeze({
  POST: 'post',
  REPOST: 'repost',
  REPLY: 'reply',
  LIKE: 'like',
  FOLLOW: 'follow',
  MILESTONE: 'milestone',
});

const getLocalizedMonths = (locale = 'en') =>
  Array.from({ length: 12 }, (_, i) => ({
    value: String(i + 1),
    label: new Intl.DateTimeFormat(locale, { month: 'long' }).format(
      new Date(2000, i)
    ),
  }));

const DateOptions = {
  getMonths: getLocalizedMonths,
  year_range: 120,
  daysInMonth(month, year) {
    if (!month || !year) return [];
    const totalDaysInMonth = new Date(year, month, 0).getDate();
    const days = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= totalDaysInMonth; i++) {
      days.push({ value: String(i), label: String(i) });
    }
    return days;
  },
  getYearsInRange(yearRange) {
    const years = [];
    const currentYear = new Date().getFullYear();
    // eslint-disable-next-line no-plusplus
    for (let i = currentYear; i >= currentYear - yearRange; i--) {
      years.push({ value: String(i), label: String(i) });
    }
    return years;
  },
};

export {
  checkIfEmpty,
  setAllObjectProperties,
  loadScript,
  STATUS,
  NOTIFICATION_TYPE,
  DateOptions,
};
